"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingScreen = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./LoadingScreen.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var LoadingScreen = function (_a) {
    var error = _a.error, currentStage = _a.currentStage, stages = _a.stages, onDismiss = _a.onDismiss;
    var _b = __read(react_1.default.useState(100), 2), leftPosition = _b[0], setLeftPosition = _b[1];
    (0, react_1.useEffect)(function () {
        setLeftPosition(100 - ((currentStage + 1) / stages.length) * 100);
    }, [currentStage]);
    var alternateButton = function () {
        switch (error === null || error === void 0 ? void 0 : error.option) {
            case "refresh":
                return react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return window.location.reload(); } }, "Refresh");
            case "retry":
                return react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { } }, "Retry Payment");
            default:
                return;
        }
    };
    return (react_1.default.createElement(kaleidoscope_1.Layer, { offset: 1054 }, function (_a) {
        var zIndex = _a.zIndex;
        return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.loadingWrapper, style: { zIndex: zIndex } }, (error === null || error === void 0 ? void 0 : error.message) ? (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.loadingContent },
            react_1.default.createElement(icons_1.Warning, { color: "critical", className: styles.errorIcon, size: icons_1.IconSize.Large }),
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xl", className: styles.errorTitle }, error.title),
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xs", className: styles.errorMessage }, error.message),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", justify: "center", gap: "m" },
                react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return onDismiss(); }, type: kaleidoscope_1.ButtonType.Secondary }, "Start again"),
                alternateButton()))) : (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.loadingContent },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", align: "center" }, stages[currentStage]),
            react_1.default.createElement("div", { className: styles.loadingBarWrapper },
                react_1.default.createElement("div", { className: styles.loadingBar },
                    react_1.default.createElement("div", { className: styles.progressBar, style: {
                            left: "-".concat(leftPosition, "%"),
                        } })),
                react_1.default.createElement("div", { className: styles.markers }, __spreadArray([], __read(Array(stages.length - 1).keys()), false).map(function (stage) {
                    return (react_1.default.createElement("div", { key: stage, className: styles.marker },
                        react_1.default.createElement(icons_1.Tick, { className: (0, classnames_1.default)(styles.tickIndicator, currentStage == stage + 1 && "active"), color: "success" })));
                }))),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", align: "center" },
                "This may take up to 30 seconds to process. ",
                react_1.default.createElement("br", null),
                "Please do not refresh this page or go back until you see a confirmation.")))));
    }));
};
exports.LoadingScreen = LoadingScreen;
